module.exports = __webpack_public_path__ + "static/media/OverallGuideline3_sm2.6d2f438c.png";